export const SET_ACCOUNT = "SET_ACCOUNT";
export const SET_POST = "SET_POST";
export const SET_LEAD = "SET_LEAD";
export const SET_MESSAGE = "SET_MESSAGE";